import React from "react";
import { Volume2, VolumeX } from "lucide-react";

const GOLD = "#c9a24b";

// Universal audio control shown on the landing/menu — mute + volume for the
// background chaos (sirens, roars, groans). Persists into the experience.
export default function LandingAudioControl({ muted, volume, onToggleMute, onVolume }) {
  return (
    <div
      data-testid="landing-audio-control"
      className="landing-audio"
      style={{
        position: "absolute", right: 20, top: 20, zIndex: 18,
        display: "flex", alignItems: "center", gap: 12, padding: "10px 14px",
        borderRadius: 999, background: "rgba(13,14,17,0.82)", backdropFilter: "blur(12px)",
        border: `1px solid ${GOLD}44`, boxShadow: "0 10px 30px rgba(0,0,0,0.5)", pointerEvents: "auto",
      }}
    >
      <button
        data-testid="landing-mute-toggle"
        onClick={onToggleMute}
        aria-label="Toggle audio"
        style={{ width: 34, height: 34, borderRadius: 999, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", background: muted ? "rgba(185,56,38,0.18)" : "rgba(201,162,75,0.12)", border: `1px solid ${muted ? "#b93826" : GOLD}66`, color: muted ? "#e0533b" : GOLD }}
      >
        {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
      </button>

      <div className="landing-vol-block" style={{ display: "flex", flexDirection: "column", gap: 3, minWidth: 150 }}>
        <span style={{ fontSize: 8.5, letterSpacing: "0.18em", textTransform: "uppercase", color: "#9aa0ac" }}>
          Ambient Chaos
        </span>
        <input
          data-testid="landing-volume-slider"
          type="range"
          min="0"
          max="100"
          value={Math.round((muted ? 0 : volume) * 100)}
          onChange={(e) => onVolume(Number(e.target.value) / 100)}
          style={{ width: "100%", accentColor: GOLD, cursor: "pointer" }}
        />
      </div>
    </div>
  );
}
